var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsOptional, IsPositive, IsUUID } from 'class-validator';
import { TherameEventDto } from '../../events/event.base.js';
import { WebhookSubscriptionFullSizeDto } from './webhook-subscription.full-size.dto.js';
export class WebhookLogEntryFullSizeDto {
    id;
    createdAt;
    updatedAt;
    event;
    response;
    error;
    webhookSubscription;
    webhookSubscriptionId;
    attemptCount;
    get webhookSubscriptionOfficeId() {
        return this.webhookSubscription.officeId;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], WebhookLogEntryFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], WebhookLogEntryFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], WebhookLogEntryFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Type(() => TherameEventDto),
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], WebhookLogEntryFullSizeDto.prototype, "event", void 0);
__decorate([
    IsObject(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], WebhookLogEntryFullSizeDto.prototype, "response", void 0);
__decorate([
    IsObject(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], WebhookLogEntryFullSizeDto.prototype, "error", void 0);
__decorate([
    Type(() => WebhookSubscriptionFullSizeDto),
    IsObject(),
    Expose(),
    __metadata("design:type", WebhookSubscriptionFullSizeDto)
], WebhookLogEntryFullSizeDto.prototype, "webhookSubscription", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], WebhookLogEntryFullSizeDto.prototype, "webhookSubscriptionId", void 0);
__decorate([
    Expose(),
    IsPositive(),
    __metadata("design:type", Number)
], WebhookLogEntryFullSizeDto.prototype, "attemptCount", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], WebhookLogEntryFullSizeDto.prototype, "webhookSubscriptionOfficeId", null);
//# sourceMappingURL=webhook-log-entry.full-size.dto.js.map